// أجزاء مستند الطلب المطبوع: رأس بالشعار، جدول تفاصيل، أزرار، توقيع، تذييل — بهوية تقارير HELCOO.
import { esc, today } from "../payroll/reportFormat";
import { printButton } from "../reports/reportButtons";
import { brandLogo, brandName } from "../payroll/reportBrand";

export const fieldRows = (kind, d, L) => {
  const n = L.none;
  const base = {
    leave: [
      [L.type, L.leaveTypes[d.leave_type] || d.leave_type],
      [L.from, d.start_date], [L.to, d.end_date], [L.days, d.total_days],
      [L.paidUnpaid, `${d.paid_days ?? 0} / ${d.unpaid_days ?? 0}`],
    ],
    advance: [
      [L.amount, `${d.amount ?? ""} ${d.currency || ""}`.trim()],
      [L.months, d.repayment_months],
      [L.installment, d.monthly_installment ?? Math.round((Number(d.amount) || 0) / (d.repayment_months || 1))],
    ],
    resignation: [
      [L.noticeDays, d.notice_days], [L.submittedOn, d.submitted_on], [L.lastDay, d.last_working_day],
    ],
    timeOff: [
      [L.type, L.timeOffTypes[d.time_off_type] || d.time_off_type],
      [L.requestDate, d.request_date], [L.hours, d.hours], [L.window, `${d.start_time || n} → ${d.end_time || n}`],
    ],
    resume: [
      [L.type, L.leaveTypes[d.leave_type] || d.leave_type], [L.from, d.start_date], [L.to, d.end_date],
    ],
  }[kind] || [];
  return [
    ...base,
    [L.reason, d.reason || n], [L.statusLabel, L.statuses[d.status] || d.status],
    [L.decisionNote, d.decision_note || n], [L.decidedBy, d.decided_by || n],
  ];
};

export const header = (L, d, kind, brand) =>
  `<div class="header">${brandLogo(brand)}${brandName(brand)}
    <h1>${esc(L.titles[kind] || "")}</h1>
    <h2>${esc(d.user_name || d.user_id || "")}</h2>
    <p>${esc(L.generatedAt)}: ${esc((d.created_at || "").slice(0, 10) || today())}</p>
  </div>`;

export const detailsTable = (L, rows) =>
  `<table><thead><tr><th>${esc(L.field)}</th><th>${esc(L.value)}</th></tr></thead><tbody>${rows
    .map(([k, v]) => `<tr><td>${esc(k)}</td><td>${esc(v ?? L.none)}</td></tr>`)
    .join("")}</tbody></table>`;

export const buttons = (L, share = null, pdfUrl = null) =>
  `<div class="pdf-bar">
    ${printButton(L)}
    ${pdfUrl ? `<button class="btn-pdfshare" data-testid="report-share-pdf" onclick="shareReportPdf()">${esc(L.sharePdf)}</button>` : ""}
    ${share?.url ? `<button class="btn-copy" data-testid="report-copy-top" onclick="copyReportLink('${esc(share.short || share.url)}')">${esc(L.copyLink)}</button>` : ""}
    <button class="btn-close" data-testid="report-close" onclick="reportClose()">${esc(L.close)}</button>
  </div>`;

export const signature = (L) =>
  `<div class="sign"><div class="sign-title">${esc(L.signTitle)}</div><div class="sign-row">${L.signRoles
    .map((r) => `<div class="sign-box"><div class="sign-role">${esc(r)}</div><div class="sign-line"></div><div class="sign-hint">${esc(L.signNameDate)}</div></div>`)
    .join("")}</div></div>`;

export const footer = (L) => `<div class="footer">${esc(L.footer)}</div>`;
